import { Controller } from 'stimulus'

// The grid's overflow-x-auto box clips the other axis too, hiding an absolute dropdown behind
// the scroll edge: on open the panel is lifted to position:fixed, anchored to the summary.
export default class extends Controller {
  connect() {
    this.summary = this.element.querySelector('summary')
    this.panel = this.element.querySelector('summary + div')
    this.onToggle = this.onToggle.bind(this)
    this.reposition = this.reposition.bind(this)
    this.onDocClick = this.onDocClick.bind(this)
    this.element.addEventListener('toggle', this.onToggle)
  }

  disconnect() {
    this.element.removeEventListener('toggle', this.onToggle)
    this.teardown()
  }

  onToggle() {
    if (this.element.open) this.open()
    else this.teardown()
  }

  open() {
    this.reposition()
    window.addEventListener('scroll', this.reposition, true)
    window.addEventListener('resize', this.reposition)
    document.addEventListener('click', this.onDocClick)
  }

  reposition() {
    const r = this.summary.getBoundingClientRect()
    Object.assign(this.panel.style, {
      position: 'fixed',
      top: `${r.bottom + 4}px`,
      left: `${r.right - this.panel.offsetWidth}px`,
      right: 'auto',
      marginTop: '0',
    })
  }

  onDocClick(e) {
    if (!this.element.contains(e.target)) this.element.open = false
  }

  teardown() {
    window.removeEventListener('scroll', this.reposition, true)
    window.removeEventListener('resize', this.reposition)
    document.removeEventListener('click', this.onDocClick)
    if (!this.panel) return
    for (const prop of ['position', 'top', 'left', 'right', 'marginTop']) {
      this.panel.style[prop] = ''
    }
  }
}
